export { GetLectureQuery } from './get-lecture';
